<lib-sticky-modal>
  <lib-sticky-header [stickyCollectionKey]="'pending-display-locations'" [stickyZ]="9" [stickyOrder]="0">
    <app-collection-displays-modal-header
      [title]="'Select Locations'"
      [showClearButton]="true"
      [disableClearButton]="!(viewModel.nSelectedLocationIds$ | async)"
      (clear)="viewModel.connectToSelectedRequiredLocationIds([])">
    </app-collection-displays-modal-header>
  </lib-sticky-header>
  <lib-sticky-body>
    <div
      libStickyAutoPosition
      class="select-locations-new-display-container"
      [style.background-color]="'white'"
      [stickyCollectionKey]="'pending-display-locations'"
      [stickyOrder]="1"
      [stickyZ]="9">
      <div class="pt-16px">
        <app-search-with-look-ahead
          [placeHolder]="'Search for a location'"
          [lookAheadItems]="viewModel.allLocations$ | async"
          [searchTheseProperties]="['name', 'address', 'city', 'state', 'country']"
          [disablePopper]="true"
          [nLookAheadItems]="10000"
          [outputAllItemsWhenSearchIsEmpty]="true"
          (searchText)="viewModel.connectToSearchString($event)"
          (lookAheadHits)="viewModel.connectToSearchedLocations($event)">
        </app-search-with-look-ahead>
      </div>
      <ng-container [ngSwitch]="(viewModel.searchedLocations$ | async)?.length > 0">
        <div *ngSwitchCase="true" class="select-all-locations-container">
          <div fxLayout="row" fxLayoutAlign="start center">
            <app-group-selection
              #groupSelectionComponent
              [selection]="viewModel.locationsVisibleOnScreen$ | async"
              [selectedIds]="viewModel.selectedRequiredLocationIdsAsStringList$ | async"
              (bulkAdd)="viewModel.addLocationIds($event)"
              (bulkRemove)="viewModel.removeLocationIds($event)">
            </app-group-selection>
            <span *ngIf="viewModel.nSelectedLocationIds$ | async as nSelected" class="checked-count">
              ({{ nSelected }})
            </span>
          </div>
          <div class="select-all-locations-text">Select All Locations</div>
        </div>
        <div *ngSwitchCase="false" class="pt-16px">No locations found.</div>
      </ng-container>
    </div>
    <div class="select-locations-new-display-container">
      <app-template-location-selection-group
        *ngFor="
          let grouping of viewModel.searchedLocationsGroupedByProvince$ | async | keyvalue: incompleteLocationsLast;
          trackBy: viewModel.trackById
        "
        [province]="grouping?.key"
        [locations]="grouping?.value"
        [updatedRequiredLocationIds]="viewModel.selectedRequiredLocationIds$ | async"
        [selectedIds]="viewModel.selectedRequiredLocationIdsAsStringList$ | async"
        (addLocationIds)="viewModel.addLocationIds($event)"
        (removeLocationIds)="viewModel.removeLocationIds($event)">
      </app-template-location-selection-group>
    </div>
  </lib-sticky-body>
  <lib-sticky-footer>
    <app-go-back-modal-footer
      [includeStickyFooterContainerClass]="false"
      [showPrimaryButton]="true"
      [primaryButtonText]="'Done'"
      [showBackButton]="true"
      [disablePrimaryButton]="viewModel.disableSubmit$ | async"
      (primaryButtonClicked)="viewModel.updatePendingDisplay()"
      (goBack)="goBack.emit()"
      (cancelClicked)="cancelClicked.emit()">
    </app-go-back-modal-footer>
  </lib-sticky-footer>
</lib-sticky-modal>
